import { render, staticRenderFns } from "./CPlayer.vue?vue&type=template&id=63091d00&scoped=true&"
import script from "./CPlayer.vue?vue&type=script&lang=js&"
export * from "./CPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63091d00",
  null
  
)

export default component.exports